import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import React, { useEffect } from "react";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import { useTable } from "react-table";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Menu } from "@material-ui/icons";
import editorConfiguration from "../../../../util/EditorConfiguration";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";

import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";

const IsDraggingContext = React.createContext(false);

const useStyles = makeStyles({
  root: {
    marginBottom: "40px",
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  button: {
    backgroundColor: "#306F9D",
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "#306F9D",
    },
  },
  draggableTableRow: {
    "&.isDragging": {
      boxShadow: "0px 2px 10px 5px #ccc",
    },
  },
});

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

class DraggableTableCell extends React.Component {
  getSnapshotBeforeUpdate(prevProps) {
    if (!this.ref) {
      return null;
    }

    const isDragStarting =
      this.props.isDragOccurring && !prevProps.isDragOccurring;

    if (!isDragStarting) {
      return null;
    }

    const { width, height } = this.ref.getBoundingClientRect();

    const snapshot = {
      width,
      height,
    };

    return snapshot;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const ref = this.ref;
    if (!ref) {
      return;
    }

    if (snapshot) {
      if (ref.style.width === snapshot.width) {
        return;
      }
      ref.style.width = `${snapshot.width}px`;
      ref.style.height = `${snapshot.height}px`;
      return;
    }

    if (this.props.isDragOccurring) {
      return;
    }

    // inline styles not applied
    if (ref.style.width == null) {
      return;
    }

    // no snapshot and drag is finished - clear the inline styles
    ref.style.removeProperty("height");
    ref.style.removeProperty("width");
  }

  setRef = (ref) => {
    this.ref = ref;
  };

  render() {
    return (
      <TableCell
        style={{
          paddingTop: 6,
          paddingBottom: 6,
          lineHeight: "1.1em",
          height: "48px",
        }}
        ref={this.setRef}
        align={this.props.align}
      >
        {this.props.children}
      </TableCell>
    );
  }
}

const VisibilityCheckbox = ({ index, defaultField, control, data, setData, visibilityValue }) => {
  return defaultField ? (
    <Controller
      control={control}
      name={`children[${index}].visibility`}
      render={({ field: { value, onChange, ...rest }, fieldState }) => {
        return (
          <Checkbox
            color="primary"
            checked={visibilityValue}
            onChange={(e) => {
              onChange(e.target.checked);
              var children = data.children;
              children[index].visibility = e.target.checked;
              setData({ ...data, children: children });
            }}
            {...rest}
          />
        );
      }}
    />
  ) : null;
};

const ComingSoonCheckbox = ({ index, defaultField, control, data, setData, comingSoonValue }) => {
  return defaultField ? (
    <Controller
      control={control}
      name={`children[${index}].comingSoon`}
      render={({ field: { value, onChange, ...rest }, fieldState }) => {
        return (
          <Checkbox
            color="primary"
            checked={comingSoonValue}
            onChange={(e) => {
              onChange(e.target.checked);
              var children = data.children;
              children[index].comingSoon = e.target.checked;
              setData({ ...data, children: children });
            }}
            {...rest}
          />
        );
      }}
    />
  ) : null;
};

function CustomTableRow(props) {
  const { row, className, index, control, field, provided, snapshot, data, setData } = props;
  return (
    <IsDraggingContext.Consumer>
      {(isDragging) => (
        <TableRow
          style={{ background: "white" }}
          className={`${className} ${snapshot.isDragging ? "isDragging" : ""}`}
          key={`customRow-${index}`}
          ref={provided.innerRef}
          isDragging={snapshot.isDragging}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <DraggableTableCell isDragOccurring={isDragging} scope="row">
            <Link
              to={`/hkiff/menu/edit/${row.original.id}`}
              style={{ textDecoration: "none", color: "#306F9D" }}
            >
              {row.cells[0].render("Cell")}
            </Link>
          </DraggableTableCell>
          <DraggableTableCell
            isDragOccurring={isDragging}
            align="left"
            style={{ color: "#306F9D" }}
          >
            {row.cells[1].render("Cell")}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging}>
            <VisibilityCheckbox
              defaultField={field}
              index={index}
              control={control}
              data={data}
              setData={setData}
              visibilityValue={row.original.visibility}
            />
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging}>
            <ComingSoonCheckbox
              defaultField={field}
              index={index}
              control={control}
              data={data}
              setData={setData}
              comingSoonValue={row.original.comingSoon}
            />
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging} align="left">
            {row.cells[4].render("Cell")}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging} align="right">
            {row.cells[5].render("Cell")}
          </DraggableTableCell>
        </TableRow>
      )}
    </IsDraggingContext.Consumer>
  );
}

function EditMenuPage({ disabled, ...props }) {
  const classes = useStyles();
  const { setLoading } = useLoading();
  const [data, setData] = React.useState({ children: [] });
  const [defaultValues, setDefaultValues] = React.useState({
    children: [],
    visibility: null,
    comingSoon: null,
    localizations: {
      en: { comingSoonContent: "" },
      tc: { comingSoonContent: "" },
    },
  });
  const [isDragging, setIsDragging] = React.useState(false);

  const id = props.match.params.id;

  const getMenu = React.useCallback(async () => {
    setLoading(true);
    const result = await apiHelper.hkiff.getHkiffMenuById(id);
    setData(result.data);
    setDefaultValues(result.data);
    setLoading(false);
  }, [id, setData, setDefaultValues]);

  const onSubmit = async (values) => {
    console.log(values);
    setLoading(true);

    const requestBody = {
      visibility: values.visibility,
      comingSoon: values.comingSoon,
      localizations: values.localizations,
      childrenStatus: data.children.map((child, index) => ({
        id: child.id,
        visibility: child.visibility,
        comingSoon: child.comingSoon,
        seq: index,
      })),
    };
    try {
      const result = await apiHelper.hkiff.updateHkiffMenuById(id, requestBody);
      console.log(result.data);
      toast.dark("Your changes is saved.");
      await getMenu();
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const onBeforeDragStart = () => {
    setIsDragging(true);
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      data.children,
      result.source.index,
      result.destination.index
    );
    setData({ ...data, children: items });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Title (English)",
        accessor: "localizations.en.title",
      },
      {
        Header: "Title (Traditional)",
        accessor: "localizations.tc.title",
      },
      {
        Header: "Visibility",
        accessor: "visibility",
      },
      {
        Header: "Coming Soon",
        accessor: "comingSoon",
        Cell: ({ value }) => (value ? 'true' : 'false'),
      },
      {
        Header: "Slug",
        accessor: "slug",
      },
      {
        Header: "",
        id: "icon",
        Cell: () => {
          return <Menu fontSize="small" style={{ color: "#CCCCCC" }} />;
        },
      },
    ],
    []
  );

  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: data.children || [],
  });

  const {
    control,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const { fields } = useFieldArray({
    control,
    name: "children",
  });

  const comingsoon = useWatch({ control, name: "comingSoon" });

  useEffect(() => {
    getMenu();
  }, []);

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  return (
    // data && (
    <Grid
      container
      xs={12}
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      direction="column"
    >
      <fieldset disabled={disabled} className="fieldset">
        <Typography variant="h4" gutterBottom>
          Menu > Edit Menu
        </Typography>
        <Box display="flex" flexDirection="column" className={classes.root}>
          <Controller
            name="localizations.en.title"
            control={control}
            defaultValue={defaultValues.localizations?.en?.title}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                margin="dense"
                label="Menu Title (English)"
                variant="outlined"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={
                  error
                    ? error.message
                    : "The name is how it appears on your site."
                }
                InputLabelProps={{ shrink: true }}
              />
            )}
            rules={{ required: "Menu Title (English) required" }}
          />
          <Controller
            name="localizations.tc.title"
            control={control}
            defaultValue={defaultValues.localizations?.tc?.title}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                margin="dense"
                label="Menu Title (Traditional Chinese)"
                variant="outlined"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={
                  error
                    ? error.message
                    : "The name is how it appears on your site."
                }
                InputLabelProps={{ shrink: true }}
              />
            )}
            rules={{
              required: "Menu Title (Traditional Chinese) required",
            }}
          />
          <Controller
            name="slug"
            control={control}
            defaultValue={defaultValues.slug}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                margin="dense"
                label="Slug"
                variant="outlined"
                value={value}
                onChange={onChange}
                error={!!error}
                disabled
                helperText={
                  error
                    ? error.message
                    : "The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens."
                }
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
          <Grid container item xs={12} direction="column">
            <Grid container item xs={12}>
              <Typography>Submenu Ordering</Typography>
            </Grid>
            <Grid item xs={12}>
              <IsDraggingContext.Provider value={isDragging}>
                <Paper>
                  <Table aria-label="simple table" {...getTableProps()}>
                    <TableHead>
                      {headerGroups.map((headerGroup) => (
                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <TableCell
                              {...column.getHeaderProps()}
                              style={{
                                paddingTop: 6,
                                paddingBottom: 6,
                                lineHeight: "1.1em",
                                height: "48px",
                              }}
                            >
                              {column.render("Header")}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableHead>
                    <DragDropContext
                      onBeforeDragStart={onBeforeDragStart}
                      onDragEnd={onDragEnd}
                    >
                      <Droppable droppableId="childMenu" type="SUBMENU">
                        {(provided, snapshot) => (
                          <TableBody
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {defaultValues.children.length > 0 &&
                              rows.map((row, index) => {
                                prepareRow(row);
                                return (
                                  <Draggable
                                    key={row.id}
                                    draggableId={row.id}
                                    index={index}
                                    isDragDisabled={disabled}
                                  >
                                    {(provided, snapshot) => (
                                      <CustomTableRow
                                        className={classes.draggableTableRow}
                                        key={`parentRow-${row.id}`}
                                        row={row}
                                        index={index}
                                        control={control}
                                        field={fields[`${index}`]}
                                        provided={provided}
                                        snapshot={snapshot}
                                        data={data}
                                        setData={setData}
                                      />
                                    )}
                                  </Draggable>
                                );
                              })}
                            {provided.placeholder}
                          </TableBody>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </Table>
                </Paper>
              </IsDraggingContext.Provider>
            </Grid>
          </Grid>
          <Box style={{ marginTop: "20px" }}>
            <Controller
              name="visibility"
              control={control}
              defaultValue={defaultValues.visibility}
              render={({
                field: { value, onChange, ...rest },
                fieldState: { error },
              }) => {
                return (
                  <FormGroup>
                    <FormControlLabel
                      key="visibility"
                      control={
                        <Checkbox
                          color="primary"
                          checked={value}
                          onChange={(event) => {
                            onChange(event.target.checked);
                          }}
                          {...rest}
                        />
                      }
                      label="Visibility"
                    />
                  </FormGroup>
                );
              }}
            />

            <Controller
              defaultValue={defaultValues.comingSoon}
              name="comingSoon"
              control={control}
              render={({
                field: { value, onChange, ...rest },
                fieldState: { error },
              }) => {
                return (
                  <FormGroup>
                    <FormControlLabel
                      key="comingsoon"
                      control={
                        <Checkbox
                          color="primary"
                          checked={value}
                          onChange={(event) => {
                            onChange(event.target.checked);
                          }}
                          {...rest}
                        />
                      }
                      label="Coming Soon"
                    />
                  </FormGroup>
                );
              }}
            />
          </Box>
          {comingsoon && (
            <>
              <Box style={{ marginTop: "20px" }}>
                <Typography>Coming Soon Content (English)</Typography>
                <Controller
                  defaultValue={
                    defaultValues.localizations.en?.comingSoonContent
                  }
                  name="localizations.en.comingSoonContent"
                  control={control}
                  render={({
                    field: { value, onChange, ...rest },
                    fieldState: { error },
                  }) => (
                    <CKEditor
                      editor={Editor}
                      config={editorConfiguration}
                      data={value || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                      }}
                      {...rest}
                    />
                  )}
                />
              </Box>
              <Box style={{ marginTop: "40px" }}>
                <Typography>
                  Coming Soon Content (Traditional Chinese)
                </Typography>
                <Controller
                  defaultValue={
                    defaultValues.localizations.tc?.comingSoonContent
                  }
                  name="localizations.tc.comingSoonContent"
                  control={control}
                  render={({
                    field: { value, onChange, ...rest },
                    fieldState: { error },
                  }) => (
                    <CKEditor
                      editor={Editor}
                      config={editorConfiguration}
                      data={value || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                      }}
                      {...rest}
                    />
                  )}
                />
              </Box>
            </>
          )}
        </Box>
        <Grid xs={12}>
          {disabled || (
            <Button
              className={classes.button}
              type="submit"
              variant="contained"
              color="primary"
            >
              Save Changes
            </Button>
          )}
        </Grid>
      </fieldset>
    </Grid>
    // )
  );
}

export default EditMenuPage;
